import React from 'react'
import { connect } from 'react-redux'
import { Menu } from 'semantic-ui-react'
import SortableOrdersTable from './SortableOrdersTable'
import Header from './Header'
import FormFilters from '../FormFilters'
import OrderScopeFilters from './OrderScopeFilters'
import { defaultFilters } from '../../helpers/orderHelpers'
import { ALL } from '../../constants/search_filters'

class ShopOrdersIndex extends React.Component {
  componentDidMount() {
    // set initial default filters
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: { ...defaultFilters(), order_scopes: [ALL] }
    })

    this.props.dispatch({ type: 'SHOP_ORDERS_LOAD_SAGA' })
  }

  render() {
    return (
      <React.Fragment>
        <Menu vertical compact className='side-filter-menu'>
          <FormFilters />
          <OrderScopeFilters />
        </Menu>
        <div className='table-section-wrapper'>
          <Header />
          <SortableOrdersTable />
        </div>
      </React.Fragment>
    )
  }
} // ShopOrdersIndex

const mapStateToProps = (state) => ({
  currentFilters: state.shopOrderFilters.currentFilters || {}
})
export default connect(mapStateToProps)(ShopOrdersIndex)
